<template>
  <li class="list_once">
    <p class="p">如何使用本地文件发起签约</p>
    <p class="text">1.在首页中点击“发起签署”进入文件发起页面；</p>
    <img class="img" src="/images/home/sign_img1.png" alt="">
    <p class="text">2.根据页面显示内容，依次上传需要签署的文件、填写签约方信息，选择审批流程（若未创建审批流程请先前往企业控制台创建），随后点击下一步；</p>
    <img class="img" src="/images/home/sign_img2.png" alt="">
    <img class="img" src="/images/home/sign_img3.png" alt="">
    <p class="text">3.根据页面提示在文件预览页面 中设置对应签署方需要用到电子签章的位置，设置完成点击 “立即发起”完成电子签约的文件发起。</p>
    <img class="img" src="/images/home/sign_img4.png" alt="">
  </li>
</template>
<script>
  export default {
    data () {
      // 这里存放数据
      return {}
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {},
  }
</script>
<style lang='less' scoped>
  // @import url(); 引入公共css类
  .list_once {
    font-size: 14px;
    padding: 10px;
    .p {
      font-size: 16px;
      font-weight: bold;
    }
    .text {
      margin: 10px 0;
    }
    .img {
      max-width: 100%;
    }
  }
</style>


// WEBPACK FOOTER //
// pages/dingtalkUse/helpCenterCom/1_localFileSign.vue